import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Cpu, Radar, Database, ArrowRight } from 'lucide-react';
import siteData from '@/data/siteData.json';

const iconMap = {
  Cpu: Cpu,
  Radar: Radar,
  Database: Database,
};

export const Categories = () => {
  const scrollToProducts = () => {
    const element = document.querySelector('#produtos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 md:py-28 bg-secondary">
      <div className="section-container">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Categorias
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            Nossas Linhas de Produtos
          </h2>
          <p className="text-muted-foreground text-base md:text-lg">
            Conheça as principais categorias de produtos que oferecemos
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {siteData.categories.map((category, index) => {
            const IconComponent = iconMap[category.icon] || Cpu;
            return (
              <Card
                key={category.id}
                className="card-industrial overflow-hidden group bg-card"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                {/* Image */}
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/20 to-transparent" />
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-lg bg-background/90 flex items-center justify-center">
                        <IconComponent className="h-6 w-6 text-foreground" />
                      </div>
                      <h3 className="font-display text-xl font-bold text-background">
                        {category.shortName}
                      </h3>
                    </div>
                  </div>
                </div>

                <CardContent className="p-6">
                  <h4 className="font-medium text-foreground mb-2">
                    {category.name}
                  </h4>
                  <p className="text-muted-foreground text-sm mb-4 leading-relaxed">
                    {category.description}
                  </p>
                  <Button
                    variant="ghost"
                    size="sm"
                    className="group/btn p-0 h-auto text-primary hover:bg-transparent"
                    onClick={scrollToProducts}
                  >
                    Ver produtos
                    <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover/btn:translate-x-1" />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
